import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import App from "./App.jsx";
import { Provider } from "react-redux";
import ScrollTop from "./components/scrollTop/ScrollTop.jsx";
import { store } from "./app/store.js";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <Router>
          <ScrollTop />
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </Provider>
  </StrictMode>
);

// <!-- Google tag (gtag.js) --> <script async src=https://www.googletagmanager.com/gtag/js?id=G-08088B7CJL></script> <script> window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-08088B7CJL'); </script>
